import React from "react";
import { Card, CardContent } from "@mui/material";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";

const ClickStatsChart = ({ data }) => {
  const theme = useSelector((state) => state.theme);

  const series = [
    {
      name: "Clicks",
      type: "area",
      data:
        (data &&
          data.click_stats &&
          data.click_stats.map((item) => item.clicks)) ||
        [],
    },
  ];

  const options = {
    colors: ["#04D9FF"],
    fill: {
      colors: "#04D9FF",
    },
    legend: {
      fontSize: "14px",
      fontWeight: 700,
      labels: {
        colors: "white",
      },
      markers: {
        width: 15,
        height: 15,
      },
    },
    chart: {
      fontFamily: "Outfit, sans-serif",
      toolbar: {
        show: false,
      },
      height: 350,
      type: "area",
      zoom: {
        enabled: true,
      },
      animations: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 4,
    },
    grid: {
      borderColor: "#415672",
      strokeDashArray: 8,
    },
    labels:
      (data &&
        data.click_stats &&
        data.click_stats.map((item) => item.created_day)) ||
      [],
    xaxis: {
      type: "datetime",
      tooltip: {
        enabled: false,
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        style: {
          colors: "#8B8E93",
          fontSize: "12px",
        },
      },
    },
    yaxis: [
      {
        type: "numeric",
        labels: {
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },
    ],
    tooltip: {
      enabled: true,
      style: {
        fontSize: "14px",
        fontWeight: "700",
      },
      x: {
        show: true,
        formatter: (val) => {
          const date = new Date(val);
          return `${date.toDateString()}`;
        },
      },
    },
  };

  return (
    <Card
      className="pushleads-chart"
      style={{
        background: "none",
        boxShadow: "none",
        border: "2px solid #293647",
        borderRadius: "20px",
      }}
    >
      <CardContent>
        <div style={{ textAlign: "left" }}>Pushleads</div>
        <ReactApexChart options={options} type="area" series={series} height={350} />
      </CardContent>
    </Card>
  );
};

export default ClickStatsChart;
